import React from 'react';

import BottomSheet from 'components/BottomSheet';
import Button from 'components/Buttons/Button';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { CancelButton, Container } from './styles';

interface ModalProps {
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  open: boolean;
  children: JSX.Element[] | JSX.Element;
  submitting?: boolean;
  confirmButton?: string;
  highlight?: boolean;
  showCancelButton: boolean;
  isModal?: boolean;
}

const ConfirmationModal = ({
  onClose,
  onConfirm,
  open,
  title,
  submitting,
  children,
  confirmButton,
  highlight = false,
  showCancelButton,
  isModal,
}: ModalProps) => {
  const { t } = useStoreTranslation();

  const closeBottomSheet = () => onClose();

  return (
    <BottomSheet
      modal={isModal ?? true}
      show={open}
      title={title}
      onClose={closeBottomSheet}
      style={{ maxHeight: 500 }}
      highlight={highlight}
      zIndex={12}
    >
      <>
        {children}
        <Container>
          <Button
            disabled={submitting}
            loading={submitting}
            value={confirmButton ?? t('confirmationModal.confirm')}
            onClick={onConfirm}
          />
          {showCancelButton && (
            <CancelButton disabled={submitting} onClick={onClose}>
              {t('confirmationModal.cancel')}
            </CancelButton>
          )}
        </Container>
      </>
    </BottomSheet>
  );
};

export default ConfirmationModal;
